module.exports = __webpack_public_path__ + "static/media/leftpanel.1e1aa208.png";